var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ loaded: _vm.loaded },attrs:{"id":"__layout__content"}},[_c('Nuxt'),_vm._v(" "),_c('GridOverlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }